import { useEffect, useRef, useState } from 'react';

import { getProtectedBlobURL } from '../../helpers/common.helpers';

export const ProtectedImage = ({ alt, className, src }) => {
  const imageRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const handleImageLoad = () => {
    URL.revokeObjectURL(imageSrc);
  };

  useEffect(() => {
    async function setProtectedImageSrc() {
      const imageBlobURL = await getProtectedBlobURL(src);
      setImageSrc(imageBlobURL);
    }

    setProtectedImageSrc();
  }, [src]);

  useEffect(() => {
    if (!imageRef.current || !imageSrc) return;

    imageRef.current.src = imageSrc;
  }, [imageSrc]);

  return <img alt={alt} className={className} onLoad={handleImageLoad} ref={imageRef} />;
};

export default ProtectedImage;
